import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { protocolsStore } from 'store/mobx/protocols.store';

const UpsertProtocolContext = createContext(null);

export const useUpsertProtocolContext = () => {
  const context = useContext(UpsertProtocolContext);
  if (!context) {
    throw new Error('useUpsertProtocolContext must be used within a UpsertProtocolProvider');
  }
  return context;
};
export const UpsertProtocolProvider = ({ children }) => {
  const [operations, setOperations] = useState([]);
  const [isFormValidate, setIsFormValidate] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [name, setName] = useState('');
  const [isActive, setIsActive] = useState(true);
  const [selectedGroup, setSelectedGroup] = useState('');
  const [groupsOptions, setGroupsOptions] = useState([]);

  const { groups } = protocolsStore;

  useEffect(() => {
    if (selectedGroup && !groups.some((group) => group.id === selectedGroup)) {
      setSelectedGroup(null);
    }
    setGroupsOptions(groups);
  }, [groups]);

  const contextValue = useMemo(
    () => ({
      operations,
      isFormValidate,
      setOperations,
      editMode,
      setEditMode,
      setIsFormValidate,
      name,
      isActive,
      selectedGroup,
      setSelectedGroup,
      setName,
      setIsActive,
      groupsOptions,
    }),
    [operations, isFormValidate, editMode, name, isActive, selectedGroup, groupsOptions],
  );

  return (
    <UpsertProtocolContext.Provider value={contextValue}>{children}</UpsertProtocolContext.Provider>
  );
};
